export function getCookieByName(cookieName: string): string | null {
  const cookieToFind = `${cookieName}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(cookieToFind)) {
      return decodeURIComponent(cookie.substring(cookieToFind.length));
    }
  }
  return null;
}
